import { TimelineMax } from "gsap";
import { SplashButton, SplashButtonType } from "./modules/SplashButton";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SanGameConfig } from "../../../SanGameConfig";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SplashViewFreeSpins} from "./views/SplashViewFreeSpins";
import { SplashViewResult, SplashViewResultData} from "./views/SplashViewResult";
import { SplashTotalWin, totalPresentationJWFS } from "./views/SplashTotalWin";
import { SplashViewJWWon } from "./views/SplashViewJWWon";
import { SplashBrokenBank } from "./views/SplashBrokenBank";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { TextStyleConfig } from "../../../translation/TextStyleConfig";
import { ReelEngineEvent } from "@nolimitcity/slot-game/bin/core/engines/reel/event/ReelEngineEvent";
import { SanJumpData } from "../../../server/data/ISanServerData";

export interface SplashView{
    play():TimelineMax;
    stop():TimelineMax;
    parseResult?(data:any):void;
    onResize():void;
}

export class SplashController {
    
    protected static _instance:SplashController;
    protected _button_continue:SplashButton;
    protected _button_Left:SplashButton;
    protected _button_Right:SplashButton;

    protected buttons:SplashButton[] = [];

    protected _indx:number = 0;

    protected readonly DEFAULT_TEXT: string = "It's time for Bonus!";
    
    protected _views:SplashView[] = [];
    protected _timeLine:TimelineMax;
    protected scrollTimer:TimelineMax;

    public static get instance():SplashController{
        return this._instance;
    }

    public get button():SplashButton{ return this._button_continue; }

    constructor(){
        SplashController._instance = this;
        this.addBaseEventListeners();
        this.createInteractiveModules();
        this.createPages();
    }

    protected createInteractiveModules():void{

        const stageCont:PIXI.Container = StageManager.getLayer(SanGameConfig.instance.LAYERS.BUTTON.name)

        this._button_continue =  stageCont.addChild(new SplashButton(() => EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP))));
        this.buttons.push(this._button_continue);
    }

    protected createPages():void{
        this._views.push(new SplashViewFreeSpins(TextStyleConfig.BONUS_RESULT_TEXT));
        this._views.push(new SplashViewResult(TextStyleConfig.BONUS_RESULT_TEXT));
        this._views.push(new SplashViewJWWon(TextStyleConfig.BONUS_RESULT_TEXT));
        this._views.push(new SplashTotalWin(TextStyleConfig.BONUS_RESULT_TEXT));
        this._views.push(new SplashBrokenBank(TextStyleConfig.BONUS_RESULT_TEXT));
    }

    public setintroVal(val:number):void{
        this._views[0].parseResult!(val);
    }

    public setResultSplash(val:SplashViewResultData):void{
        this._views[1].parseResult!(val);
    }

    

    public setResultTotal(val:totalPresentationJWFS):void{
        this._views[3].parseResult!(val);
    }

    public playRestore():TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine,new TimelineMax());
        for(let b:number = 0; b < this.buttons.length; b++) this._timeLine.add(this.buttons[b].showButton(),0);
        return this._timeLine;
    }

    public stop():void{
        Helper.timeLineKiller(this._timeLine);
        Helper.timeLineKiller(this.scrollTimer);
        this.buttons.forEach(btn => { btn.hideButton() });
        this._views[this._indx].stop();
    }
    
    protected addBaseEventListeners():void {
        EventHandler.addEventListener(this, ReelEngineEvent.REEL_RESIZED, () => this.onResize());
    }

    public play(viewIndx:number,cb?:Function):TimelineMax{
        this._indx = viewIndx;

        this._timeLine = Helper.timeLineKiller(this._timeLine,new TimelineMax());
        this._timeLine.add(this._views[this._indx].play());

        if(viewIndx == 0 || viewIndx >= 3){
            // this.buttons[0].changeText(TranslationConfig.CONTINUE);
            this._timeLine.add(this.buttons[0].showButton(cb));
        }

        return this._timeLine;
    }

    public onResize():void{
        this._views.forEach(s => { s.onResize() });

        this.buttons.forEach(btn => { btn.onResize() });
    }
}
